import { FC, PropsWithChildren } from "react";
import { twMerge } from "tailwind-merge";

export const DisplayPillBox: FC<PropsWithChildren<{ className?: string }>> = ({
  children,
  className,
}) => {
  return (
    <div
      className={twMerge("atlas-bg-blue-100 atlas-px-2 atlas-py-0.5 atlas-rounded-md", className)}
    >
      <span className="atlas-text-xs atlas-font-semibold">{children}</span>
    </div>
  );
};
